<template>
    <v-data-table
      :headers="headers"
      :items="listadoContratosRelacionados">
      <template v-slot:[`item.esSupervisionExterna`]="{ item }">
        <v-icon
          v-if="item.esSupervisionExterna"
          color="green">
            mdi-check-bold
          </v-icon>
          <!-- <v-icon
          v-else
          color="grey">
            mdi-close-thick
          </v-icon> -->
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoContratosRelacionados',
  props: {
    listadoContratosRelacionados: {
      type: Array,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'contratoRelacionado.numero',
        },
        { text: 'Objeto', value: 'contratoRelacionado.meta', sortable: false },
        {
          text: 'Contratista',
          value: 'contratoRelacionado.contratista.nombreRazonSocial',
          sortable: false,
        },
        {
          text: 'Supervision Externa',
          align: 'center',
          width: '100',
          value: 'esSupervisionExterna',
          sortable: false,
        },
        {
          text: '',
          align: 'end',
          width: '50',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    borrar(contratoRelacionado) {
      eventBus.$emit('eliminar-contrato-relacionado', contratoRelacionado);
    },
  },
};
</script>

<style lang="scss">

</style>
